/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { toQueryString } from '../../api-helpers';
import { CustomerActivityDetailDto, fixCustomerActivityDetailDtoFromJson } from '../dto/customer-activity-detail-dto';

export interface GetCustomerActivityRecordGetDetailQueryParams {
  recordId?: string;
}

export interface GetCustomerActivityRecordGetDetailParams {
  query: GetCustomerActivityRecordGetDetailQueryParams;
}

export function httpGetCustomerActivityRecordGetDetail(http: HttpClient, data: GetCustomerActivityRecordGetDetailParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<CustomerActivityDetailDto[]>;
export function httpGetCustomerActivityRecordGetDetail(http: HttpClient, data: GetCustomerActivityRecordGetDetailParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<CustomerActivityDetailDto[]>>;
export function httpGetCustomerActivityRecordGetDetail(http: HttpClient, data: GetCustomerActivityRecordGetDetailParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<CustomerActivityDetailDto[]>(`{placeholder}/CustomerActivityRecord/GetDetail?${toQueryString(data.query)}`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as CustomerActivityDetailDto[];
      dto?.forEach((x, i, a) => fixCustomerActivityDetailDtoFromJson(a[i]));
    })
  );
};

export const urlGetCustomerActivityRecordGetDetail = (baseUrl: string, data: GetCustomerActivityRecordGetDetailParams) => {
  return `${baseUrl}/CustomerActivityRecord/GetDetail?${toQueryString(data.query)}`;
};
